import { FRAGMENT_CARD_PADDING_X, FRAGMENT_LIST_CONTAINER_SX } from '../constants';

/**
 * Shared styles for clickable fragment cards: cursor, border, transition and hover.
 * Used by list layout (FragmentCardListBase); grid cards use AppCard interactive styles.
 */
export const fragmentCardInteractiveSx = {
  cursor: 'pointer',
  border: '1px solid transparent',
  transition: 'box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out',
  '&:hover': {
    boxShadow: 4,
    borderColor: 'primary.main',
  },
} as const;

/** Grid card body padding (passed to AppCardContent on FragmentCardBase). */
export const fragmentGridCardContentSx = {
  pb: 1,
  pt: 1.5,
  px: FRAGMENT_CARD_PADDING_X,
} as const;

/** List card layout: row flex, container width, padding, plus interactive styles. */
export const fragmentCardListSx = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'stretch',
  width: '100%',
  ...FRAGMENT_LIST_CONTAINER_SX,
  ...fragmentCardInteractiveSx,
  p: FRAGMENT_CARD_PADDING_X,
  gap: FRAGMENT_CARD_PADDING_X,
} as const;
